import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import { trackEvent } from '../analytics';

export const HolidayBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = React.useState(() => {
    // Check localStorage to see if user has closed the banner
    const bannerClosed = localStorage.getItem('holidayBannerClosed');
    return !bannerClosed;
  });

  // Check if current date is after December 31, 2025
  const isAfterDeadline = () => {
    const currentDate = new Date();
    const deadline = new Date('2025-12-31T23:59:59');
    return currentDate > deadline;
  };

  // Don't show banner after December 31, 2024
  if (isAfterDeadline()) {
    return null;
  }

  // Don't show banner on the holiday special page itself
  if (location.pathname === '/holiday-special') {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  const handleBannerClick = () => {
    trackEvent('holiday_banner_click', {
      from_page: location.pathname
    });
    navigate('/holiday-special');
  };

  const handleClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    localStorage.setItem('holidayBannerClosed', 'true');
    trackEvent('holiday_banner_close', {
      from_page: location.pathname
    });
    setIsVisible(false);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-red-600 via-green-600 to-red-600 text-white shadow-lg animate-slideDown">
      <div className="w-full px-2 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between gap-1.5 sm:gap-2 py-2 sm:py-3">
          {/* Text content - responsive */}
          <div className="flex items-center gap-1 sm:gap-2 flex-1 min-w-0 overflow-hidden">
            <Sparkles className="hidden xs:block h-4 w-4 sm:h-5 sm:w-5 text-yellow-300 animate-pulse flex-shrink-0" />
            <span className="text-[10px] xs:text-xs sm:text-sm md:text-base font-semibold whitespace-nowrap overflow-hidden text-ellipsis">
              <span className="hidden md:inline">🎄 Holiday Special - Deep Cleaning $180 | SAVE $70!</span>
              <span className="hidden sm:inline md:hidden">🎄 Holiday Special $180</span>
              <span className="sm:hidden">🎄 $180 Deal</span>
            </span>
          </div>
          
          {/* Buttons */}
          <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
            <button
              onClick={handleBannerClick}
              className="bg-yellow-400 hover:bg-yellow-300 text-gray-900 px-2.5 py-1 xs:px-3 xs:py-1.5 sm:px-4 sm:py-2 rounded-full font-bold text-[10px] xs:text-xs sm:text-sm transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <span className="hidden xs:inline">View Offer</span>
              <span className="xs:hidden">View</span>
            </button>
            
            <button
              onClick={handleClose}
              className="p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0"
              aria-label="Close banner"
            >
              <X className="h-4 w-4 sm:h-5 sm:w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};